import { mapLinkableEntityType, mapShowWithTourType } from '@api';
import type { TicketSalesType } from 'src/api/generated/touring/types';
import type { TicketSalesResultType } from '../../types';
import { mapSalesMetricType } from '../mapSalesMetricType';

export const mapTicketSalesResultType = (
  api: TicketSalesType
): TicketSalesResultType => ({
  ticketSalesId: api.ticketSalesId,
  showWithTour: mapShowWithTourType(api.showWithTour),
  showDateInfo: api.showDateInfo,
  coPro: api.coPro ? mapLinkableEntityType(api.coPro) : null,
  buyer: api.buyer ? mapLinkableEntityType(api.buyer) : null,
  tourProd: api.tourProd ? mapLinkableEntityType(api.tourProd) : null,
  tourRep: api.tourRep ? mapLinkableEntityType(api.tourRep) : null,
  tourAcc: api.tourAcc ? mapLinkableEntityType(api.tourAcc) : null,
  ticketsSold: api.ticketsSold,
  ticketsSellable: api.ticketsSellable,
  salesTimeline: api.salesTimeline.map(mapSalesMetricType),
});
